<ng-container *ngTemplateOutlet="footerContainer"></ng-container>

<ng-template #footerContainer>
  <section *ngIf="!!showFooter">
    <div class="liner-container" *ngIf="showLinerSection">

  <div class="liner-header">
    <div class="liner-header-p" style="display: flex; align-items: center; gap: 15px;margin-bottom:10px;"><h2 class="liner-main-title">Vessel Schedules from Leading Global Shipping Lines</h2><div class="live-badge">Live Schedules <span class="live-dot"></span>  </div></div>
    <p class="liner-sub-title">Instant vessel schedules from trusted global shipping liners.</p>
  </div>

  <div class="liner-view-toggle-wrapper" #expandedState>
    
    <div class="liner-grid liner-mobile-vertical-stack" [class.is-expanded]="expandedState.getAttribute('data-show') === 'true'">
      <div *ngFor="let item of filteredLinerSeoData ;let i = index" 
           class="liner-card"
           [class.hide-mobile-item]="i >= 3 && expandedState.getAttribute('data-show') !== 'true'">
        <div  class="liner-link">
          <div class="liner-left">
            <div class="liner-icon">
              <!-- <span class="material-symbols-outlined" style="color: white;">directions_boat</span> -->
              <img src="{{$any(item.value).logo}}" alt="{{$any(item.value).name}}" style="height: 100%;width:100%;" loading="lazy" decoding="async" width="40" height="40">
            </div>
            <a [routerLink]="['/port-to-port', item.key]" class="pointer"><span class="liner-name"> {{ $any(item.value)?.name }} </span></a>
          </div>
          <span class="material-symbols-outlined">chevron_right</span>
        </div>
      </div>
    </div>

    <div class="liner-toggle-action-box">
      <button class="liner-toggle-btn" 
              (click)="expandedState.setAttribute('data-show', expandedState.getAttribute('data-show') === 'true' ? 'false' : 'true')">
        {{ expandedState.getAttribute('data-show') === 'true' ? 'Show Less' : 'View All Liners' }}
        <span class="material-symbols-outlined">
          {{ expandedState.getAttribute('data-show') === 'true' ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
        </span>
      </button>
    </div>

  </div>

</div>

    <div class="footer-top">
      
      <div class="footer-brand">
        <!-- <h2 class="brand-name"><span class="brand-mark"><span style="position: relative;display: inline-block;font-size: clamp(3.25rem, 5vw, 3rem);"> a <span  style="position: absolute;top: 0px;left: 0.05em;right: 0.05em;height: 2.5px;background: currentColor;"></span></span>tmavaan</span></h2> -->
        <h2 class="brand-name"><span class="brand-mark"><span style="position: relative;display: inline-block;font-size: clamp(3.25rem, 5vw, 3rem);">a<span style="position: absolute;top: 0px;left: 0.05em;right: 0.05em;height: 2.5px;background: currentColor;"></span></span>tmavaan</span></h2>
        <p class="brand-tagline">FREIGHT WITH SOUL · ON TIME, EVERY TIME</p>
      </div>

      <div class="footer-locations">
  
        <div class="footer-locations-main-blck">
        
        <div class="location-block">
          <h3 class="location-title">
            <span class="material-symbols-outlined location-icon">location_on</span>
            <a href="https://maps.app.goo.gl/996H9NPB6qFMvD2j9" target="_blank">USA &mdash; Atmavaan, Inc.</a>
          </h3>
          <address class="location-address">
            2945 Townsgate Road, Suite 200<br>
            Westlake Village, CA 91361
          </address>
          <div class="location-contact">
            <a href="tel:+18053720284">+1 805-372-0284</a> &middot; 
            <a href="mailto:kesh@atmavaan.com" (click)="composeEmail('kesh@atmavaan.com')">kesh&#64;atmavaan.com</a>
          </div>
        </div>

        <div class="location-block">
          <h3 class="location-title">
            <span class="material-symbols-outlined location-icon">location_on</span>
            <a href="https://maps.app.goo.gl/iCxGJ17V316m5vXJ9" target="_blank">India &mdash; Atmavaan Logistics Pvt Ltd</a>
          </h3>
          <address class="location-address">
            Ega Trade Center, Poonamallee High Road<br>
            Kilpauk, Chennai 600010
          </address>
          <div class="location-contact">
            <a href="tel:+918925962778">+91 8925 962 778</a> &middot; 
            <a href="mailto:booking@atmavaan.com" (click)="composeEmail('booking@atmavaan.com')">booking&#64;atmavaan.com</a>
          </div>
        </div>

        <div class="location-block">
          <h3 class="location-title">
            <span class="material-symbols-outlined location-icon">location_on</span>
            <a href="https://maps.app.goo.gl/E8RUzud4adMjQUKE8" target="_blank">Canada &mdash; Atmavaan, Inc.</a>
          </h3>
          <address class="location-address">
            729 Galloway Crescent<br>
            Mississauga, ON L5C 3R8, Canada
          </address>
          <div class="location-contact">
            <a href="tel:+14167050859">+1 416-705-0859</a> &middot;
            <a href="mailto:chitra@atmavaan.com" (click)="composeEmail('chitra@atmavaan.com')">chitra&#64;atmavaan.com</a>
          </div>
        </div>

        </div>

      </div>
    </div>
    <div class="footer-wrap">
  <div class="footer-grid">
 
    <div *ngFor="let footer of footerList; index as i"
         class="footer-c flex flex-d-c service white
         {{footer.name == 'service' ? '' : 'margin-t-0'}}">
 
      <div class="flex align-c justify-space-between" (click)="toggleSubtabs(i)">
        <div class="footer-title foot-f-c-16 f-w-600 mar-b-10 con-c opac-07">
          {{footer?.title}}
        </div>
      </div>
 
      <div>
        <ng-container *ngFor="let subtab of footer.subtab">
 
          <ng-container *ngIf="subtab.section">
            <div class="footer-link flex align-c mar-tb-10" *ngFor="let item of subtab.items">
              <span class="material-symbols-outlined chev">chevron_forward</span>
              <div class="pointer con-c-r" (click)="routePage(item)">{{item.name}}</div>
            </div>
          </ng-container>
 
     <ng-container *ngIf="!subtab.section">
  <div class="footer-link flex align-c mar-tb-16">
    <span class="material-symbols-outlined chev">chevron_forward</span>

    <a
      *ngIf="subtab.external"
      class="pointer con-c-r"
      [href]="subtab.route"
      target="_blank"
      rel="noopener">
      {{ subtab.name }}
    </a>

    <div
      *ngIf="!subtab.external"
      class="pointer con-c-r"
      (click)="routePage(subtab)">
      {{ subtab.name }}
    </div>
  </div>
</ng-container>
 
        </ng-container>
      </div>
    </div>
 
  </div>
</div>
 
<div class="footer-bottom">
  <p>&copy; Atmavaan 2026 &middot; All rights reserved.</p>
  <!-- Opens the cookie preferences dialog. Required by California law to be
       reachable from every page; the banner component owns the dialog. -->
  <a *ngIf="consentService.applies" class="ft-privacy-choices" role="button" tabindex="0"
    (click)="openPrivacyChoices()" (keydown.enter)="openPrivacyChoices()"
    (keydown.space)="openPrivacyChoices()">Do not sell or share my personal information</a>
</div>